import cChart from './cChart.vue';

export default {
  install(Vue) {
    Vue.component('cChart', cChart);
  },
};
